/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';
import urlgetter from './getMainUrl';

const api = create({
	baseURL: urlgetter.getMainApiUrl()
});

const func = {};

func.loadTandemStudents = () =>{
	//console.log('in loadTandemStudents');
    return api.get('/tandemStudents');
}

func.loadTodayTandemStudents = () =>{
	//console.log('in load today tandem students');
    let sDate = new Date();
    sDate = sDate.setHours(0, 0, 0, 0);
    let startDate = new Date(sDate);
    startDate = startDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');

    let eDate = new Date();
    eDate = eDate.setHours(23, 59, 59, 999);
    let endDate = new Date(eDate);
    endDate = endDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');
  
    return api.get('/tandemStudents?start='+startDate+'&end='+endDate);
}

export default func;